/** Audiences: dialog, list, targeting (components/audiences/*, pages/audiences.tsx). */
export const audiences = {
  page: {
    title: "Audiences",
    description:
      "Reusable targeting groups that map devices and locations to your schedules.",
    newAudience: "New Audience",
    searchPlaceholder: "Search audiences…",
  },

  card: {
    default: "Default",
  },

  error: {
    title: "Couldn't load audiences",
    description:
      "Something went wrong while loading your audiences. Check your connection and try again.",
  },

  empty: {
    noMatch: "No audiences match your filters.",
    none: "No audiences yet. Create one to target schedules at specific devices.",
    noneTitle: "No audiences yet",
    noMatchTitle: "No matches",
    clearSearch: "Clear search",
  },

  dialog: {
    editTitle: "Edit audience",
    createTitle: "New audience",
    namePlaceholder: "e.g. West Coast cafes",
    descriptionPlaceholder: "Optional description",
    targeting: "Targeting",
    createSubmit: "Create audience",
    deleteLabel: "Delete audience",
    confirmDelete: "Delete this audience?",
  },

  toast: {
    incompleteRuleTitle: "Incomplete rule",
    incompleteRuleDescription:
      "Each targeting rule needs a location, device, or label.",
    updated: "Audience updated",
    created: "Audience created",
    saveFailed: "Failed to save audience",
    deleted: "Audience deleted",
    deleteInUse: "This audience can't be deleted while in use",
  },
} as const;
